<template>
    <div
        class="button-group"
        :class="buttonGroupClasses"
    >
        <div
            class="row"
            :class="buttonGroupRowClasses"
        >
            <div class="columns">
                <slot />
            </div>
        </div>
    </div>
</template>

<script>
    /**
    * Component
    */
    export default {
        name: 'btn-group',
        props: {
            collapse: {
                type: Boolean,
                required: false,
                default: false
            },
            align: {
                type: String,
                required: false,
                default: 'left'
            },
            dark: {
                type: Boolean,
                required: false,
                default: false
            }
        },
        computed: {
            buttonGroupClasses () {
                return {
                    'dark': this.dark,
                    'collapse': this.collapse
                }
            },
            buttonGroupRowClasses () {
                return {
                    'align-right': this.align === 'right',
                    'align-left': this.align === 'left'
                }
            }
        }
    }
</script>

<style lang="scss">
    .button-group {

        &.dark {
            background: #f5f5f5;
            padding: 30px;
            border-top: 1px solid #d8d8d8;
        }

        .row.align-right {
            button {
                margin-left: 15px;
            }
        }

        .row.align-left {
            button {
                margin-right: 15px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/general/BtnGroup.vue